module.exports = __webpack_public_path__ + "static/media/kids_19.cb98d3b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_19.jpg
// module id = 5875
// module chunks = 0